import { createSelector } from 'reselect';

/* ---------------------------------------------------------------
 * Action Types
 */

const SET_PLAN_SETTINGS_PREDICTION_ACTIVE =
  'SET_PLAN_SETTINGS_PREDICTION_ACTIVE' as const;

export const PlanSettingsActionTypes = {
  SET_PLAN_SETTINGS_PREDICTION_ACTIVE,
};

/* ---------------------------------------------------------------
 * Action Creators
 */

/**
 * 予定登録画面で予測更新状態がアクティブかどうかを切り替える
 */
function setPlanSettingsPredictionActiveAction(isActive: boolean) {
  return {
    type: SET_PLAN_SETTINGS_PREDICTION_ACTIVE,
    payload: { isActive },
  };
}

export const PlanSettingsActionCreators = {
  setPlanSettingsPredictionActiveAction,
};

/* ---------------------------------------------------------------
 * Actions
 */

type PlanSettingsAction = ReturnType<
  typeof setPlanSettingsPredictionActiveAction
>;

/* ---------------------------------------------------------------
 * State
 */

type PlanSettingsState = {
  isPredictionActive: boolean;
};

const initialState: PlanSettingsState = {
  isPredictionActive: false,
};

/* ---------------------------------------------------------------
 * Selector
 */

function planSettingsSelector(rootState: { planSettings: PlanSettingsState }) {
  return rootState.planSettings;
}

/**
 * [予定登録] 予測更新状態がアクティブかどうか
 * - 「予測更新」ボタン押下で true になる
 * - キャンセル / 予測確定 / 店舗変更 で false に戻る
 * - Saga 側で年月変更後の最新予測再取得を行うかの判定に使う
 */
export const planSettingsIsPredictionActiveSelector = createSelector(
  planSettingsSelector,
  (planSettings) => planSettings.isPredictionActive
);

/* ---------------------------------------------------------------
 * Reducer
 */

export function planSettingsReducer(
  state = initialState,
  action: PlanSettingsAction
): PlanSettingsState {
  switch (action.type) {
    case SET_PLAN_SETTINGS_PREDICTION_ACTIVE:
      return {
        ...state,
        isPredictionActive: action.payload.isActive,
      };

    default:
      return state;
  }
}
